/**
 * Normalize axios / fetch errors into user-facing messages.
 */
export const getApiErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again."
) => {
  if (!error) return fallback;

  if (error.code === "ERR_CANCELED") {
    return null;
  }

  const data = error.response?.data;

  if (typeof data === "string" && data.trim()) {
    return data;
  }

  if (data?.Response_Data?.Message) {
    return data.Response_Data.Message;
  }

  if (data?.Message) {
    return data.Message;
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.error) {
    return data.error;
  }

  const status = error.response?.status;
  if (status === 404) {
    return "The requested resource was not found.";
  }
  if (status === 403) {
    return "You do not have permission to perform this action.";
  }
  if (status >= 500) {
    return "Server error. Please try again later.";
  }

  if (error.message === "Network Error") {
    return "Network error. Please check your connection and try again.";
  }

  if (error.message) {
    return error.message;
  }

  return fallback;
};

/** Log CPI debug block returned by backend when SAP_CPI_DEBUG=true */
export const logSapCpiDebug = (error, label = "SAP/CPI") => {
  const debug = error?.response?.data?.cpiDebug;
  if (!debug) return;
  console.group(`[${label}] CPI debug`);
  console.log("endpoint:", debug.cpiEndpoint);
  console.log("suffix:", debug.cpiSuffix);
  console.log("payload:", debug.cpiPayload);
  console.log("responseStatus:", debug.cpiResponseStatus);
  console.log("response:", debug.cpiResponse);
  console.groupEnd();
};
